import { render, staticRenderFns } from "./GuestMenuCard2.vue?vue&type=template&id=62720e56&scoped=true&"
import script from "./GuestMenuCard2.vue?vue&type=script&lang=js&"
export * from "./GuestMenuCard2.vue?vue&type=script&lang=js&"
import style0 from "./GuestMenuCard2.vue?vue&type=style&index=0&id=62720e56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62720e56",
  null
  
)

export default component.exports